import { useCallback, useEffect, useRef, useState } from "react";
import { FileCheck2, Loader2, Download } from "lucide-react";
import api, { fileUrl } from "../lib/api";

export const SignedProposalArchive = ({ leadId, onSaved }) => {
  const [quotes, setQuotes] = useState([]);
  const saved = useRef(onSaved);
  saved.current = onSaved;
  const load = useCallback(async () => {
    const { data } = await api.get(`/leads/${leadId}/signed-proposals`);
    setQuotes(data);
  }, [leadId]);
  useEffect(() => { load().catch(() => {}); const timer = setInterval(() => load().catch(() => {}), 5000); return () => clearInterval(timer); }, [load]);
  const savedKey = quotes.map(q => q.file_id || "").join(",");
  useEffect(() => { if (savedKey.replaceAll(",", "")) saved.current?.(); }, [savedKey]);
  if (!quotes.length) return null;
  return <section className="space-y-2 mb-4" data-testid="signed-proposal-archive">
    <h3 className="font-semibold text-sm flex items-center gap-2"><FileCheck2 size={17} /> Signed proposals</h3>
    {quotes.map(q => {
      const working = ["queued", "rendering", "retry"].includes(q.status);
      return <div key={q.id} className="flex flex-wrap items-center justify-between gap-3 border-b border-border py-3" data-testid={`signed-archive-${q.id}`}>
        <div className="min-w-0 text-sm">
          <div className="font-semibold break-words">{q.quote_no} · {q.option_label}</div>
          <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1.5" data-testid={`signed-archive-status-${q.id}`}>
            {working && <Loader2 size={13} className="animate-spin" />}
            {q.status === "ready" ? "Signed copy saved" : q.status === "retry" ? "Save delayed — retrying automatically" : working ? "Saving signed copy…" : "Signed copy needs saving"}
          </div>
          {q.error && <p className="text-xs text-amber-700 mt-1" data-testid={`signed-archive-error-${q.id}`}>{q.error}</p>}
          {q.email_status && <p className="text-xs text-muted-foreground mt-1" data-testid={`signed-email-status-${q.id}`}>
            Signing emails: {({ accepted: "accepted by mail provider", queued: "queued", retry: "retrying", failed: "failed — see admin Error Logs", suppressed: "suppressed for this lead" })[q.email_status] || q.email_status}
          </p>}
        </div>
        {q.status === "ready" && q.file_id ? <a href={fileUrl(q.file_id) + "?download=1"} data-testid={`signed-archive-download-${q.id}`} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-sm text-secondary font-semibold"><Download size={15} /> Signed PDF</a>
          : null}
      </div>;
    })}
  </section>;
};